const PaymentService = {
    confirmTransaction: function (data) {
        let url = '/monri/payment/confirm';

        return $.ajax({
            async: true,
            url: url,
            type: 'JSON',
            data: {data: JSON.stringify(data)},
            method: 'POST',
            error: function (response) {
                console.log('Ajax error');
            }
        });
    },
}

export {PaymentService};
